export default __webpack_public_path__ + "static/news-illus-aeb72c754f12dfc8df58c192fe51aee1.svg";